//Add  Form
export const ADD_FORM = 'ADD_FORM';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_ERROR = 'ADD_FORM_ERROR';

//Assign CHARGER
export const ASSIGN_CHARGER = 'ASSIGN_CHARGER';
export const ASSIGN_CHARGER_SUCCESS = 'ASSIGN_CHARGER_SUCCESS';
export const ASSIGN_CHARGER_FAIL = 'ASSIGN_CHARGER_FAIL';

//Fetch  CHARGERS
export const FETCH_CHARGERS = 'FETCH_CHARGERS';
export const FETCH_CHARGERS_SUCCESS = 'FETCH_CHARGERS_SUCCESS';
export const FETCH_CHARGERS_FAIL = 'FETCH_CHARGERS_FAIL';

//Fetch  Forms
export const FETCH_FORMS = 'FETCH_FORMS';
export const FETCH_FORMS_SUCCESS = 'FETCH_FORMS_SUCCESS';
export const FETCH_FORMS_FAIL = 'FETCH_FORMS_FAIL';

//Fetch  Forms
export const FETCH_FORM = 'FETCH_FORM';
export const FETCH_FORM_SUCCESS = 'FETCH_FORM_SUCCESS';
export const FETCH_FORM_FAIL = 'FETCH_FORM_FAIL';
export const UNSET_FORM = 'UNSET_FORM';

//Update  Form
export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_FORM_SUCCESS = 'UPDATE_FORM_SUCCESS';
export const UPDATE_FORM_ERROR = 'UPDATE_FORM_ERROR';

//Delete  Form
export const DELETE_FORM = 'DELETE_FORM';
export const DELETE_FORM_SUCCESS = 'DELETE_FORM_SUCCESS';
export const DELETE_FORM_ERROR = 'DELETE_FORM_ERROR';

export const CHANGE_STEP = 'CHANGE_STEP';

export const ASSIGN_TO_CONTRACTOR = 'ASSIGN_TO_CONTRACTOR';
export const ASSIGN_TO_CONTRACTOR_SUCCESS= 'ASSIGN_TO_CONTRACTOR_SUCCESS';
export const ASSIGN_TO_CONTRACTOR_FAIL = 'ASSIGN_TO_CONTRACTOR_FAIL';

export const ASSIGN_TO_MANAGER = 'ASSIGN_TO_MANAGER';
export const ASSIGN_TO_MANAGER_SUCCESS = 'ASSIGN_TO_MANAGER_SUCCESS';
export const ASSIGN_TO_MANAGER_FAIL = 'ASSIGN_TO_MANAGER_FAIL';


export const changeStep = (step) => {
  return { type: CHANGE_STEP, payload: step };
};

export const getForm = (formId) => {
  return { type: FETCH_FORM, payload: formId };
};

export const saveForm = (values) => {
  return { type: ADD_FORM, payload: values };
};

export const updateForm = (formId, values) => {
  return {
    type: UPDATE_FORM,
    payload: {
      formId,
      values,
    },
  };
};

export const unsetForm = () => {
  return { type: UNSET_FORM };
};


//Create Checklist
export const CREATE_CHECKLIST = 'CREATE_CHECKLIST';
export const CREATE_CHECKLIST_SUCCESS = 'CREATE_CHECKLIST_SUCCESS';
export const CREATE_CHECKLIST_FAIL = 'CREATE_CHECKLIST_FAIL';

export const FETCH_FORMS_LIST = 'FETCH_FORMS_LIST'
export const FETCH_FORMS_LIST_SUCCESS = 'FETCH_FORMS_LIST_SUCCESS'
export const FETCH_FORMS_LIST_FAIL = 'FETCH_FORMS_LIST_FAIL'

export const FETCH_STATION_WISE_FORMS = 'FETCH_STATION_WISE_FORMS'
export const FETCH_STATION_WISE_FORMS_SUCCESS = 'FETCH_STATION_WISE_FORMS_SUCCESS'
export const FETCH_STATION_WISE_FORMS_FAIL = 'FETCH_STATION_WISE_FORMS_FAIL'

export const SUBMIT_FORM = 'SUBMIT_FORM'
export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS'
export const SUBMIT_FORM_FAIL = 'SUBMIT_FORM_FAIL'

export const VIEW_FORM = 'VIEW_FORM'
export const VIEW_FORM_SUCCESS = 'VIEW_FORM_SUCCESS'
export const VIEW_FORM_FAIL = 'VIEW_FORM_FAIL'

export const DOWNLOAD_CHECKLIST_FORM = 'DOWNLOAD_CHECKLIST_FORM'
export const DOWNLOAD_CHECKLIST_FORM_SUCCESS = 'DOWNLOAD_CHECKLIST_FORM_SUCCESS'
export const DOWNLOAD_CHECKLIST_FORM_FAIL = 'DOWNLOAD_CHECKLIST_FORM_FAIL'


export const STATUS_CHANGE = 'STATUS_CHANGE'
export const STATUS_CHANGE_SUCCESS = 'STATUS_CHANGE_SUCCESS'
export const STATUS_CHANGE_FAIL = 'STATUS_CHANGE_FAIL'

export const DELETE_CHECKLIST_FORM = 'DELETE_CHECKLIST_FORM'
export const DELETE_CHECKLIST_FORM_SUCCESS = 'DELETE_CHECKLIST_FORM_SUCCESS'
export const DELETE_CHECKLIST_FORM_FAIL = 'DELETE_CHECKLIST_FORM_FAIL'

export const DOWNLOAD_FULL_PDF = 'DOWNLOAD_FULL_PDF'
export const DOWNLOAD_FULL_PDF_SUCCESS = 'DOWNLOAD_FULL_PDF_SUCCESS'
export const DOWNLOAD_FULL_PDF_FAIL = 'DOWNLOAD_FULL_PDF_FAIL'
